export default __webpack_public_path__ + "images/SummerAnnouncementsBackground.png";